



import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { User } from 'src/app/_models/user';
import { UserService } from 'src/app/_services/user.service';



import Swal from 'sweetalert2';
@Component({
  selector: 'app-new-guardian',
  templateUrl: './new-guardian.component.html',
  styleUrls: ['./new-guardian.component.css']
})
export class NewGuardianComponent implements OnInit {

  form: FormGroup;
  loading = false;
  submitted = false;
  responseMessage = '';
  errorEncountered=false
  isRegistrationSuccess=false
  roles: string[] = [];
  user:User=new User()
  registeredUser=new User()
  reasons = [{id:1, name:"normal"},{id:2, name:"staff"},{id:3, name:"trial"}]


  constructor(
      private formBuilder: FormBuilder,
      private router: Router,
      private userService:UserService

  ) {}

  ngOnInit() {
      this.form = this.formBuilder.group({
        username: ['', Validators.compose([Validators.required, Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'), Validators.minLength(1)])],
        password: ['', Validators.compose([Validators.required,Validators.minLength(5)])],
        passwordConfirmation: ['', Validators.compose([Validators.required,Validators.minLength(5)])],
        reason: ['', Validators.required]

      });

      this.userService.registrationData
      .subscribe( value => {
        this.registeredUser = value;
       });

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(): void {
      this.submitted = true;
      if(!this.checkPasswords()){
        Swal.fire( 'Oops',"Passwords do no match",'info')
        return
      }
      if(!this.checkObviousPasswords){
        Swal.fire( 'Oops',"The password cannot be the same as email",'info')
        return
      }


      this.user.username=this.form.value.username
      this.user.password=this.form.value.password
      this.user.passwordConfirmation=this.form.value.passwordConfirmation
      let x=this.form.value.reason
      for(let xx of this.reasons){
        if(xx.id==x){
          this.user.reason=xx.name
          break
        }
      }



        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.errorEncountered=false
        this.userService.newGuardian(this.user).subscribe(
          xx=>{
            this.router.navigate(['/guardian/show',xx])
          },
          err=>{
            this.loading=false
            this.responseMessage = err.error.message;
            this.isRegistrationSuccess=false
            this.errorEncountered=true
          }
        )
  }


  reloadPage(): void {
    window.location.reload();
  }
  checkPasswords(){
    let isOk=true
    if(this.f.password.touched || this.f.passwordConfirmation.touched){
      isOk = this.f.password.value==this.f.passwordConfirmation.value
    }
    return isOk
  }

  checkObviousPasswords(){
      return this.form.value.password == this.form.value.email
  }
}
